import { Box, FormHelperText, Grid, Typography, useTheme } from '@mui/material';
import React, { useState, useEffect } from 'react';
import OtpInput, { InputProps } from 'react-otp-input';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { maskMobileNumber } from '../../utils/utilityFunctions';
import { useDispatch } from 'react-redux';
import { sendOtp, verifyOtp } from '../../redux-store/actions/onBoarding';
import {
  ApplicationProps,
  CreateApplicationProps,
  SendOtpResponseBody,
  VerifyOtpResponseBody,
} from '../../redux-store/types/api-types';
import { addJointHolder, createApplication } from '../../redux-store/actions/application';
import { OtpTimer } from '../commonComponents';
import { Location } from 'history';
import { Formik } from 'formik';
import { MFSubmitButton } from '../../lib/formik';
import { showError } from '../../redux-store/actions/auth';
import { VERIFY_LOGIN_OTP_SUCCESS } from '../../redux-store/types/auth';
import { InfoIconOutlined } from '../../assets/SvgIcons';



export default function EnterOTP({
  location,
}: {
  location: Location<{
    mobile: string;
    unmaskedphone: string;
    umaskedemailId: string;
    otpVerificationToken: string;
    application: ApplicationProps;
    redirectTo: string;
    panVerificationToken: string;
    countryCode: string;
    email: string;
    countryNameAndCode: string;
    accountType: string;
    applicantStatus?: string
  }>;
}): JSX.Element {
  const theme = useTheme()
  const { path: currentPathName } = useRouteMatch();
  const { mobile = '', redirectTo = '', application, email = '', countryCode = '', applicantStatus = "" } = location.state || {};
  const { id } = application || {};
  const history = useHistory();
  const dispatch = useDispatch();
  const [error, setError] = useState<string>('');
  const [otpError, setOtpError] = useState<{ OTP: string, EmailOTP?: string }>({
    OTP: '',
    EmailOTP: ''
  });
  const [{ otpVerificationToken }, setOtpInfo] = useState({
    otpVerificationToken: '',
  });
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const intialValues: { OTP: string } = {
    OTP: ''
  };

  const isInvestorDiyOnboarding = currentPathName === '/investor-onboarding/enter-otp'
  const isDiyJointHolder = currentPathName.includes('add-diy-joint-holder')

  const handleSubmit = async (values: { OTP: string }) => {
    const { OTP } = values;
    try {


      if (!OTP || OTP.length !== 6) {
        setError('Enter OTP');
        return;
      }
      setIsLoading(true)
      const response = (await dispatch(
        verifyOtp({ otpVerificationToken, otp: OTP }, (isInvestorDiyOnboarding || isDiyJointHolder))
      )) as unknown as VerifyOtpResponseBody;
      if (response) {
        const { applicantVerificationToken, investorToken, role } = response || {};
        if (isInvestorDiyOnboarding) {
          dispatch({
            type: VERIFY_LOGIN_OTP_SUCCESS, body: {
              token: investorToken,
              role: role
            }
          })
        }
        if (id && redirectTo) {
          const res = (await dispatch(
            addJointHolder({ applicantVerificationToken }, id)
          )) as unknown as CreateApplicationProps;
          if (!res?.isSuccess) {
            dispatch(showError(res?.message as string));
            history.goBack();
            return;
          }
          history.push(redirectTo, { ...(res?.application || {}) });
          setIsLoading(false)
          return;
        }
        const res = (await dispatch(
          createApplication({ applicantVerificationToken })
        )) as unknown as CreateApplicationProps;

        if (!res) return

        if (!res?.isSuccess) {
          setIsLoading(false);
          dispatch(showError(res?.message as string));
          history.goBack();
          return;
        }
        // history.push('/application', { ...(res?.application || {}) });
        if (res?.application?.applicationType === 'individual') {
          history.push(isInvestorDiyOnboarding ? '/investor-onboarding-application/rm-details' : '/application', { ...(res?.application || {}) });
        } else {
          history.push('/non-individual-application', { ...(res?.application ?? {}) });
        }
        setIsLoading(false)
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setIsLoading(false)
    }
  };

  useEffect(() => {
    const { otpVerificationToken } = location.state || {};
    if (!location.state) {
      history.push('/');
    }
    setOtpInfo({ otpVerificationToken });
  }, []);

  const onResend = async () => {
    try {
      const {
        panVerificationToken,
        countryCode,
        countryNameAndCode,
        email,
        unmaskedphone,
        umaskedemailId,
        accountType
      } = location.state;

      const countryCodeCheck = countryNameAndCode?.split(':')[1].trim();

      const res = (await dispatch(
        sendOtp({
          phoneNumber: unmaskedphone,
          emailId: umaskedemailId,
          panVerificationToken,
          countryCode,
          countryNameAndCode,
          bypassOtp: false,
          // ...((isInvestorDiyOnboarding || isDiyJointHolder) ? {
          //   accountType: isDiyJointHolder ? "" : "EXECUTIONARY"
          // } : { accountType })
          accountType
        }, (isInvestorDiyOnboarding || isDiyJointHolder))
      )) as unknown as SendOtpResponseBody;
      const { otpVerificationToken } = res || {};
      setOtpInfo({ otpVerificationToken });
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return (
    <Formik initialValues={intialValues} onSubmit={handleSubmit}>
      {({ values, setValues, handleSubmit }) => (
        <Grid
          container
          component="form"
          noValidate
          onSubmit={handleSubmit}
          px={{ xs: 1, sm: 4 }}
          rowSpacing={2.5}
        // sx={{
        //   '.MuiTypography-root': {
        //     fontSize: 16,
        //     fontWeight: 500,
        //     textAlign: 'center',
        //   },
        // }}
        >

          <Grid item xs={12}>
            <Typography
              variant="body_500"
              color="text.primary"
              sx={{
                wordWrap: "break-word",
                textAlign: { xs: "center", sm: "left" },
              }}
            >
              An OTP has been sent to your mobile number
              <Typography component="span" color="primary.500" variant="body_500">
                {" "}
                {mobile}
              </Typography>
              {email && (
                <Typography component="span" color="text.primary" variant="body_500">
                  {' '}
                  and email Id{' '}
                  <Typography component="span" color="primary.500" variant="body_500">
                    {''}
                    {email}
                  </Typography>
                </Typography>
              )}
            </Typography>
          </Grid>


          <Grid item xs={12}>
            <OtpInput
              inputType='number'
              renderInput={(inputProps: InputProps) => <input {...inputProps} type='password' style={{ ...inputProps.style }} disabled={isLoading} />}
              value={values.OTP}
              onChange={(OTP: string) => setValues({ OTP })}
              numInputs={6}
              // hasErrored={!!error}
              // isInputNum={true}
              // isInputSecure={true}
              shouldAutoFocus={true}
              containerStyle={{
                display: "flex",
                justifyContent: "center",
                gap: "8px",
              }}
              inputStyle={{
                width: "min(12vw, 35px)",
                height: "min(12vw, 50px)",
                backgroundColor: `${theme.palette.primary[500]}1A`,
                // border: 0,
                // borderBottom: '1px solid #979797',
                // fontSize: '30px',
                border: `1px solid ${theme.palette.primary[500]}`,
                borderRadius: "10px",
                outline: 'none',
                borderColor: error ? `${theme.palette.common.red}` : `${theme.palette.text.primary}`,
                color: error ? `${theme.palette.common.red}` : `${theme.palette.text.primary}`,
                ...(theme.typography.body_600)
              }}
            // errorStyle={{ border: `1px solid ${theme.palette.error[500]}`, color: 'error.500' }}
            // focusStyle={{ outline: 'none' }}
            />
            {!!error && (
              <FormHelperText
                error
                sx={{
                  mt: 2,
                  textAlign: { xs: "center", sm: "left" },
                  fontSize: "14px",
                }}
              >
                {error}
              </FormHelperText>
            )}
          </Grid>


          <Grid
            item
            xs={12}
            sx={{ textAlign: { xs: "center", sm: "left" }, mt: { xs: 1, sm: 0 } }}
          >
            <OtpTimer onResend={onResend} />
          </Grid>


          <Grid item xs={12} mt={3}>
            <MFSubmitButton label="Submit" loadingEnable={isLoading} fullWidth />
          </Grid>


          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginTop: "10px",
              gap: "5px",
              flexDirection: { xs: "column", sm: "row" },
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            <InfoIconOutlined />
            <Typography variant="overline_400">
              Keep Your Password/Pin/OTP private & confidential to avoid any misuse
              or unauthorised trades.
            </Typography>
          </Box>
        </Grid>
      )
      }
    </Formik >
  );
}

// export function RedirectScreen(): JSX.Element {
//   return (
//     <>
//       <Typography sx={{ fontSize: 24, fontWeight: 'bold', color: 'primary.main' }}>
//         You are now being redirected to Onboard Investor Form
//       </Typography>
//       {/* <MFSubmitButton label="Next" to="/distributor-details" /> */}
//     </>
//   );
// }
